import React, {FC} from "react";
import {ImplementationActionTable} from "../../../tables/action-table/ImplementationActionTable";

const ActionStep: FC = () => {
  return (
    <ImplementationActionTable/>
  )
}

export {ActionStep}
